<script lang="ts" setup>
import AppModal from "@/components/AppModal.vue";
import CreateSearchForm from "@/features/searches/CreateSearchForm.vue";
import type { Search } from "~/common/types/types";

const search = defineModel({
  required: true,
  type: Object as PropType<Search>   
})

const emit = defineEmits(["close", "submitted"]);

function closed() {
    emit("close");
}

function submitted(search: Search) {
  emit("submitted", search);
  closed();
}

</script>
<template>
  <AppModal @close="closed">
    <template #title> Create Search </template>
    <template #body>
      <CreateSearchForm @submitted='submitted' v-model="search" />
    </template>
  </AppModal>
</template>